/* eslint-disable camelcase */
import { useMemo, useContext } from 'react';
// import ReactEcharts from 'echarts-for-react';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts';
import Head from '@/containers/chart_box/Head';
import Body from '@/containers/chart_box/Body';
import { ThemeContext } from 'styled-components';
import { BrandContext } from '@/contexts/ContextProviders';
import { transNum, isEmptyObject } from '@/utils/comUtil';
// import webStorage from '@/utils/storageManager';
import { sinTimeDimensionSinIndexMulValue } from '@/utils/reportResponseUtil';
import { BarChart } from 'echarts/charts';
// import components, all suffixed with Component
import { TitleComponent } from 'echarts/components';
import {
  CanvasRenderer,
  // SVGRenderer,
} from 'echarts/renderers';

// Register the required components
echarts.use([TitleComponent, CanvasRenderer, BarChart]);

// 图表容器样式与坐标轴格式化函数提到模块级，保证引用稳定，
// 避免 ReactEChartsCore 因为 props 引用变化而重复 setOption
const CHART_STYLE = { width: '100%', height: '100%' };
const alwaysShowInterval = () => {
  return true;
};
const fmtAxisTransNum = (p) => {
  return transNum(p);
};
const fmtBarLabelTransNum = (p) => {
  return transNum(p.value);
};

const SourceDistribution = (props) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);

  const { charts } = themeContext[brandContext];
  const { chartsFontSize, fontFamily } = themeContext.comm;
  const { loading, data, boxId, categoryOrder } = props;
  // 渲染阶段直接计算 option，图表挂载时拿到的就是完整配置，
  // 避免先挂载空 option 再由 effect 补一次而绘制两遍
  const chartOption = useMemo(() => {
    if (isEmptyObject(data) || isEmptyObject(data)) {
      return {};
    }

    // const DICTOBJ = webStorage.get('DICTOBJ');
    let xDataUse = [];
    let seriesData = [];
    const chartData = sinTimeDimensionSinIndexMulValue(data || []);
    if (categoryOrder) {
      const order = new Map(
        categoryOrder.map((label, index) => [label, index]),
      );
      chartData.sort(
        (a, b) =>
          (order.get(a.LABEL) ?? categoryOrder.length) -
          (order.get(b.LABEL) ?? categoryOrder.length),
      );
    }
    chartData.forEach((e) => {
      xDataUse.push(e.LABEL);
      seriesData.push(e.VALUE);
    });
    let option = {
      textStyle: {
        fontSize: chartsFontSize.s03,
        fontFamily: fontFamily,
      },
      // barWidth: 30,
      barCategoryGap: '50%',
      grid: {
        top: 15,
        left: 10,
        right: 10,
        bottom: -5,
        containLabel: true,
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        textStyle: {
          fontSize: chartsFontSize.s03,
        },
      },
      xAxis: {
        type: 'category',
        data: xDataUse, // ['天猫', '京东', '小程序', '线下门店'],
        // data: channelName,
        axisLabel: {
          color: charts.xColor, //坐标值得具体的颜色
          // fontSize: chartsFontSize.s03,
          fontSize: chartsFontSize.s01,
          rotate: 20,
          interval: alwaysShowInterval,
        },
        axisTick: false,
        axisLine: {
          lineStyle: {
            color: charts.axisLineColor,
          },
        },
      },
      yAxis: {
        type: 'value',
        axisTick: false,
        axisLine: false,
        axisLabel: {
          color: charts.yColor, //坐标值得具体的颜色
          fontSize: chartsFontSize.s03,
          formatter: fmtAxisTransNum,
        },
        splitLine: {
          show: true, //去除网格线
          lineStyle: {
            color: charts.axisLineColor, //坐标线的颜色
          },
        },
        // name: '人',
        // nameRotate: 45,
        nameGap: 15,
        nameTextStyle: {
          padding: [0, 35, 0, 0],
        },
        min: 0,
      },
      color: charts.barColorList,
      series: {
        data: seriesData,
        type: 'bar',
        barWidth: '30%',
        itemStyle: {
          normal: {
            label: {
              show: true,
              position: 'top',
              color: charts.xColor,
              formatter: fmtBarLabelTransNum,
            },
          },
        },
      },
    };

    return option;
  }, [
    data,
    categoryOrder,
    chartsFontSize.s03,
    chartsFontSize.s01,
    fontFamily,
    charts.xColor,
    charts.axisLineColor,
    charts.yColor,
    charts.barColorList,
  ]);

  return (
    <>
      {/* <Head boxId={'ec.dashboard.n04.lbl01'}></Head> */}
      <Head boxId={boxId}></Head>
      <Body bizData={data} loading={loading}>
        {/* <ReactEcharts
          style={{ width: '100%', height: '100%' }}
          option={echartsOptions || {}}
          notMerge={true}
          lazyUpdate={true}
          //   onEvents={onEvents}
        /> */}
        <ReactEChartsCore
          echarts={echarts}
          lazyUpdate={true}
          option={chartOption}
          notMerge={true}
          style={CHART_STYLE}
        />
      </Body>
    </>
  );
};
export default SourceDistribution;
